import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { WarningTriangleIcon } from "@/components/icons"

export function TooManyRequestsPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(60)

  const retrySeconds = Number.parseInt(searchParams.get("retry") || "60", 10)

  useEffect(() => {
    setCountdown(retrySeconds)

    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval)
          // Retry the previous action
          navigate(-1)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [retrySeconds, navigate])

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Warning Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
            <WarningTriangleIcon className="w-10 h-10 text-orange-500" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Too Many Requests</h1>

        {/* Description */}
        <p className="text-gray-600 mb-6">
          You've made too many requests in a short period. Please wait before trying again.
        </p>

        {/* Countdown Timer */}
        <div className="mb-6">
          <div className="text-5xl font-bold text-orange-500 mb-2">{countdown}</div>
          <p className="text-sm text-gray-500">seconds remaining</p>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-2 mb-6 overflow-hidden">
          <div
            className="bg-orange-500 h-2 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(countdown / retrySeconds) * 100}%` }}
          />
        </div>

        {/* Auto Retry Message */}
        <p className="text-sm text-gray-500">You'll be automatically redirected in a moment...</p>

        {/* Manual Retry Button */}
        <button
          onClick={() => navigate(-1)}
          className="mt-4 px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
        >
          Try Again Now
        </button>
      </div>
    </div>
  )
}
